import { gql } from '@apollo/client';

export default gql`
  fragment TopicSummaryFields on Topic {
    id
    name
    privacy
    memberEditable
    contributors {
      id
    }
    inheritedAncestors {
      id
    }
  }
`;
